/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Request_SendInputs */

const en_invoice_request_send = /** @type {(inputs: Invoice_Request_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send request`)
};

const pl_invoice_request_send = /** @type {(inputs: Invoice_Request_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyślij prośbę`)
};

/**
* | output |
* | --- |
* | "Send request" |
*
* @param {Invoice_Request_SendInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const invoice_request_send = /** @type {((inputs?: Invoice_Request_SendInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Request_SendInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_invoice_request_send(inputs)
	return en_invoice_request_send(inputs)
});